import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PetDeleteConfirmPage } from './pet-delete-confirm.page';

const routes: Routes = [
  {
    path: '',
    component: PetDeleteConfirmPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PetDeleteConfirmPage]
})
export class PetDeleteConfirmPageModule {}
